import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { translations } from '../../i18n'
import Loader from '../../components/Loader'

const MONTHS_IT = {
  January: 'Gennaio', February: 'Febbraio', March: 'Marzo', April: 'Aprile',
  May: 'Maggio', June: 'Giugno', July: 'Luglio', August: 'Agosto',
  September: 'Settembre', October: 'Ottobre', November: 'Novembre', December: 'Dicembre',
}

function CVSection() {
  const { lang } = useSelector(s => s.rootReducer.langRed)
  const T = translations[lang]
  const { loading, work = [], education = [] } = useSelector(s => s.rootReducer.cvRed)

  if (loading) return <section id='cv' className='fc-section'><Container><Loader /></Container></section>

  const field = (item, base) => item[`${base}_${lang}`] || item[`${base}_en`] || ''
  const fmtDate = (d) => lang === 'it' ? d.replace(/January|February|March|April|May|June|July|August|September|October|November|December/g, m => MONTHS_IT[m]) : d

  return (
    <section id='cv' className='fc-section bg-alt'>
      <Container>
        <h2 className='section-title'>{T.sections.cv}</h2>
        <Row>
          <Col md={6}>
            <div className='cv-sub-title'>{T.sections.work}</div>
            <div className='timeline'>
              {work.map(w => (
                <div className='timeline-item' key={w.id}>
                  <div className='timeline-dot'></div>
                  <div className='timeline-date'>
                    {fmtDate(w.start_date)} — {w.end_date ? fmtDate(w.end_date) : T.cv.present}
                  </div>
                  <div className='timeline-title'>{field(w, 'title')}</div>
                  <div className='timeline-org'>{(lang === 'it' && w.company_it) ? w.company_it : w.company}{w.location ? ` · ${w.location}` : ''}</div>
                  {field(w, 'description') && (
                    <div className='timeline-desc'>{field(w, 'description')}</div>
                  )}
                </div>
              ))}
            </div>
          </Col>
          <Col md={6}>
            <div className='cv-sub-title'>{T.sections.education}</div>
            <div className='timeline'>
              {education.map(e => (
                <div className='timeline-item' key={e.id}>
                  <div className='timeline-dot'></div>
                  <div className='timeline-date'>{e.year}</div>
                  <div className='timeline-title'>{field(e, 'degree')}</div>
                  <div className='timeline-org'>{e.institution}</div>
                  {field(e, 'thesis') && (
                    <div className='timeline-note'>"{field(e, 'thesis')}"</div>
                  )}
                  {e.grade && <div className='timeline-desc' style={{marginTop:'.2rem'}}>{e.grade}</div>}
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default CVSection
